import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, minWidth, Text, TextElements } from '@calm-web/design-system';

export const PatentPageContainer = styled.div`
	background: ${palette('gray1')};
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const PatentContentBlock = styled.div`
	background: ${palette('white')};
	border-radius: 12px;
	box-shadow: 0 10px 25px -5px ${palette('blackAlpha10')};
	max-width: 900px;
	width: 100%;
	padding: 48px 32px;
	margin: 64px auto;

	${minWidth('tablet')} {
		padding: 64px 48px;
		margin: 80px auto;
	}
`;

export const PatentTitle = styled(Text).attrs({
	el: TextElements.H1,
	size: FontSizes.xl,
	weight: FontWeights.Medium,
	color: 'gray8',
})`
	border-bottom: 3px solid ${palette('gray3')};
	padding-bottom: 32px;
	margin-bottom: 48px;
	text-align: center;

	${minWidth('tablet')} {
		font-size: 40px;
	}
`;

export const LegalText = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.base,
	weight: FontWeights.Regular,
	color: 'gray7',
})`
	line-height: 1.8;
	margin-bottom: 48px;
	font-size: 18px;
`;

export const ReferencedTitle = styled(Text).attrs({
	el: TextElements.H2,
	size: FontSizes.lg,
	weight: FontWeights.Demi,
	color: 'gray8',
})`
	margin: 24px 0 16px 0;
	font-size: 22px;
`;

export const PatentList = styled.ul`
	list-style: none;
	padding: 0;
	margin-bottom: 32px;
`;

export const PatentItem = styled.li`
	background-color: ${palette('gray0')};
	padding: 10px 16px;
	margin-bottom: 8px;
	border-left: 5px solid ${palette('gray3')};
	border-radius: 6px;
	font-size: 15px;
	color: ${palette('gray7')};
	font-weight: 500;
`;

export const LastUpdate = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.sm,
	weight: FontWeights.Regular,
	color: 'gray6',
})`
	font-style: italic;
	margin-top: 48px;
	text-align: center;
	font-size: 15px;
`;

export const LastUpdateDate = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.sm,
	weight: FontWeights.Regular,
	color: 'gray6',
})`
	text-align: left;
	font-size: 14px;
	text-align: center;
`;

export const BoldText = styled(Text).attrs({
	weight: FontWeights.Demi,
})``;
